/**
 * @internal
 */
export class GaugeComponentViewbox {
  static readonly WIDTH = 320
  static readonly HEIGHT = 190

  static get CENTER(): number {
    return GaugeComponentViewbox.WIDTH / 2
  }
}
